"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInternalSpacingStyles = void 0;
var _react = require("react");
var marginStyles = _interopRequireWildcard(require("../../styles/margin"));
var paddingStyles = _interopRequireWildcard(require("../../styles/padding"));
var _isRtl = require("../../utils/isRtl");
var _linaria = require("../../utils/linaria");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const useInternalSpacingStyles = ({
  all,
  bottom,
  end,
  horizontal,
  start,
  top,
  vertical,
  isInverted = false
}) => (0, _react.useMemo)(() => {
  const spacingClasses = [];
  const styles = isInverted ? marginStyles : paddingStyles;
  if (all !== undefined) {
    spacingClasses.push(styles.all[all]);
  }
  if (vertical !== undefined) {
    spacingClasses.push(styles.top[vertical]);
    spacingClasses.push(styles.bottom[vertical]);
  }
  if (horizontal !== undefined) {
    spacingClasses.push(styles.left[horizontal]);
    spacingClasses.push(styles.right[horizontal]);
  }
  if (top !== undefined) {
    spacingClasses.push(styles.top[top]);
  }
  if (bottom !== undefined) {
    spacingClasses.push(styles.bottom[bottom]);
  }
  if (start !== undefined) {
    if ((0, _isRtl.isRtl)()) {
      spacingClasses.push(styles.right[start]);
    } else {
      spacingClasses.push(styles.left[start]);
    }
  }
  if (end !== undefined) {
    if ((0, _isRtl.isRtl)()) {
      spacingClasses.push(styles.left[end]);
    } else {
      spacingClasses.push(styles.right[end]);
    }
  }
  return (0, _linaria.cx)(...spacingClasses);
}, [all, top, bottom, start, end, vertical, horizontal, isInverted]);
exports.useInternalSpacingStyles = useInternalSpacingStyles;